module.exports = __webpack_public_path__ + "static/media/s9.63771a36.ogg";